import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

// lodash
import _differenceWith from 'lodash-es/differenceWith';
import _isEqual from 'lodash-es/isEqual';
import _find from 'lodash-es/find';

// sushi
import Searchbox from 'sushiweb/Searchbox/Searchbox';
import MenuItem from 'sushiweb/MenuItem';
import grey from 'sushiweb/tokens/color/grey';

/*
    NOTE: please make sure that the allItems, selectedItems and unselectedItems are of type
    [
        {
            label: ..., (required)
            name: ..., (required)
            desc: ..., (optional)
        },
        ...
    ]
*/

const StyledSearchBox = styled(Searchbox)`
  p {
    justify-content: center;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const HelperText = styled.div`
  font-size: 1.1rem;
  color: ${grey.z600};
`;
function SelectItems({
  allItems,
  selectedItems,
  unSelectedItems,
  placeholder,
  updateSelectedItems,
  updateUnSelectedItems,
  checkLength,
  selectedItemsLength,
  disabled,
  helperText,
}) {
  const handleChange = value => {
    // if no input, then show all the available options
    if (value === '') {
      updateUnSelectedItems(_differenceWith(allItems, selectedItems, _isEqual));
      return;
    }

    // otherwise get the matching results from available options
    const matches = unSelectedItems.filter(group =>
      group.label.includes(value),
    );
    updateUnSelectedItems(matches);
  };

  const handleSelect = values => {
    // values -> array of values within the searchbox [value1, value2, ...]
    // getting groups with those values
    const results = values.map(value => _find(allItems, { value }));
    const diff = _differenceWith(allItems, results, _isEqual);

    updateSelectedItems(results);
    if (checkLength && results.length === selectedItemsLength) {
      updateUnSelectedItems([]);
    } else {
      updateUnSelectedItems(diff);
    }
  };

  // jsx
  return (
    <div style={{ pointerEvents: disabled ? 'none' : 'all' }}>
      <StyledSearchBox
        type='tag'
        align='center'
        onChange={handleChange}
        onSelect={handleSelect}
        width='100%'
        maxMenuHeight='20rem'
        maxLength='50'
        placeholder={placeholder}
        selectedTags={selectedItems}
        tagType={disabled ? 'grey' : 'red'}
        disabled
        NoResultComponent={(
          <div style={{ padding: '10px', color: grey.z500 }}>
            {' '}
            {checkLength
              ? `Only ${selectedItemsLength} items can be selected`
              : 'No results found!'}
            {' '}
          </div>
        )}
      >
        {unSelectedItems.map(item => (
          <MenuItem
            key={item.value}
            label={item.label}
            desc={item.desc}
            value={item.value}
          />
        ))}
      </StyledSearchBox>
      {helperText.length !== '' && <HelperText>{helperText}</HelperText>}
    </div>
  );
}

SelectItems.propTypes = {
  updateSelectedItems: PropTypes.func.isRequired,
  updateUnSelectedItems: PropTypes.func.isRequired,
  allItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  unSelectedItems: PropTypes.arrayOf(PropTypes.any).isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  checkLength: PropTypes.bool,
  selectedItemsLength: PropTypes.number,
};

SelectItems.defaultProps = {
  disabled: false,
  helperText: '',
  placeholder: '',
  checkLength: false,
  selectedItemsLength: 0,
};

export default SelectItems;
